// Add Entries here so we can dynamically generate vuex modules for entities or for lookup/options
export const EntityModules = Object.freeze({
  ASSOCIATED_INSTRUMENTS: {
    namespace: 'AssociatedInstruments',
    parentType: 'Property',
    entityType: 'Instruments',
  },
  ASSOCIATED_PROPERTIES: {
    namespace: 'AssociatedProperties',
    parentType: 'Instrument',
    entityType: 'Properties',
  },
  ASSOCIATED_SERVICES: {
    namespace: 'AssociatedServices',
    parentType: 'Property',
    entityType: 'Services',
  },
  SERVICE_PROPERTIES: {
    namespace: 'ServiceProperties',
    parentType: 'Service',
    entityType: 'Properties',
  },
  BUILT_ENVIRONMENT_FEATURE: {
    namespace: 'BuiltEnvironmentFeature',
    parentType: 'Property',
    entityType: 'BuiltEnvironmentFeatures',
  },
  CONSERVATION_PURPOSE: {
    namespace: 'ConservationPurpose',
    parentType: 'Instrument',
    entityType: 'ConservationPurposes',
  },
  INSTRUMENT_CONTACT: {
    namespace: 'InstrumentContact',
    parentType: 'Instrument',
    entityType: 'Contacts',
  },
  PROPERTY_CONTACT: {
    namespace: 'PropertyContact',
    parentType: 'Property',
    entityType: 'Contacts',
  },
  SERVICE_CONTACT: {
    namespace: 'ServiceContact',
    parentType: 'Service',
    entityType: 'Contacts',
  },
  PROJECT_CONTACT: {
    namespace: 'ProjectContact',
    parentType: 'Project',
    entityType: 'Contacts',
  },
  INSTRUMENT_EVENT: {
    namespace: 'InstrumentEvent',
    parentType: 'Instrument',
    entityType: 'Events',
  },
  INSTRUMENT_REVIEW: {
    namespace: 'InstrumentReview',
    parentType: 'Instrument',
    entityType: 'Reviews',
  },
  SERVICE_EVENT: {
    namespace: 'ServiceEvent',
    parentType: 'Service',
    entityType: 'Events',
  },
  SERVICE_REVIEW: {
    namespace: 'ServiceReview',
    parentType: 'Service',
    entityType: 'Reviews',
  },
  LOCALITY: {
    namespace: 'Locality',
    parentType: 'Property',
    entityType: 'Localities',
  },
  PARTNERSHIP_GRANT: {
    namespace: 'PartnershipGrant',
    parentType: 'Instrument',
    entityType: 'PartnershipGrants',
  },
  PROJECT: {
    namespace: 'Project',
    parentType: null,
    entityType: null,
  },
  BUILDING_ACTIVITY_AREA: {
    namespace: 'BuildingActivityArea',
    parentType: 'Instrument',
    entityType: 'BuildingActivityAreas',
  },
  WATER_QUALITY_PROTECTION_AREA: {
    namespace: 'WaterQualityProtectionArea',
    parentType: 'Instrument',
    entityType: 'WaterQualityProtectionAreas',
  },
  OPEN_REVIEWS: {
    namespace: 'openReviews',
    parentType: 'Project',
    entityType: 'OpenReviews',
  },
});

export const LookupModules = Object.freeze({
  PROJECT_STATUSES: {
    namespace: 'ProjectStatuses',
    url: '/project/projectstatuses',
  },
  BUILDING_ACTIVITY_AREA_TYPES: {
    namespace: 'BuildingActivityAreaTypes',
    url: '/buildingactivityarea/types',
  },
  PRIMARY_SOURCES: {
    namespace: 'PrimarySources',
    url: '/primarySources',
  },
  PURPOSES: {
    namespace: 'Purposes',
    url: '/conservationPurpose/purposes',
  },
  INSTRUMENT_EVENT_TYPES: {
    namespace: 'InstrumentEventTypes',
    url: '/event/instrumenteventtypes',
  },
  SERVICE_EVENT_TYPES: {
    namespace: 'ServiceEventTypes',
    url: '/event/serviceeventtypes',
  },
  AGREEMENT_TYPES: {
    namespace: 'AgreementTypes',
    url: '/instrument/agreementtypes',
  },
  INSTRUMENT_TYPES: {
    namespace: 'InstrumentTypes',
    url: '/instrument/instrumenttypes',
  },
  INSTRUMENT_TAGS: {
    namespace: 'InstrumentTags',
    url: '/instrument/instrumenttags',
  },
  INSTRUMENT_STATUSES: {
    namespace: 'InstrumentStatuses',
    url: '/instrument/instrumentstatuses',
  },
  INSTRUMENT_ROLES: {
    namespace: 'InstrumentRoles',
    url: '/instrument/contactroles',
  },
  LOCALITIES: {
    namespace: 'LookupLocalities',
    url: '/locality/localities',
  },
  GRANT_PROGRAMS: {
    namespace: 'GrantPrograms',
    url: '/partnershipGrant/grantPrograms',
  },
  PROPERTY_STATUSES: {
    namespace: 'PropertyStatuses',
    url: '/property/propertystatuses',
  },
  PROPERTY_ROLES: {
    namespace: 'PropertyRoles',
    url: '/property/contactroles',
  },
  REVIEW_STATUSES: {
    namespace: 'ReviewStatuses',
    url: '/review/statuses',
  },
  FEATURE_TYPES: {
    namespace: 'FeatureTypes',
    url: '/waterQualityProtectionArea/featureTypes',
  },
  GEOMETRY_TYPES: {
    namespace: 'GeometryTypes',
    url: '/waterQualityProtectionArea/geometryTypes',
  },
  BUFFER_RESTRICTIONS: {
    namespace: 'BufferRestrictions',
    url: '/waterQualityProtectionArea/bufferRestrictions',
  },
  LIVESTOCK_RESTRICTIONS: {
    namespace: 'LivestockRestrictions',
    url: '/waterQualityProtectionArea/livestockRestrictions',
  },
  TIMBER_HARVEST_RESTRICTIONS: {
    namespace: 'TimberHarvestRestrictions',
    url: '/waterQualityProtectionArea/timberHarvestRestrictions',
  },
  SERVICE_CATEGORIES: {
    namespace: 'ServiceCategories',
    url: '/service/categories',
  },
  SERVICE_TYPES: {
    namespace: 'ServiceTypes',
    url: '/service/types',
  },
  TAG_TYPES: {
    namespace: 'TagTypes',
    url: '/instrument/tagtypes',
  },
  SERVICE_STATUSES: {
    namespace: 'ServiceStatuses',
    url: '/service/statuses',
  },
  SERVICE_PRODUCTS: {
    namespace: 'ServiceProducts',
    url: '/service/products',
  },
  SERVICE_OBSERVATION_TYPES: {
    namespace: 'ServiceObservationTypes',
    url: '/service/observationtypes',
  },
  SERVICE_OBSERVATION_ACK_TYPES: {
    namespace: 'ObservationAcknowledgementTypes',
    url: '/service/observationacknowledgementtypes',
  },
  SERVICE_IMAGERY_ASSESSMENT_SOURCES: {
    namespace: 'ServiceImageryAssessmentSources',
    url: '/service/imageryassessmentsources',
  },
  SERVICE_ROLES: {
    namespace: 'ServiceRoles',
    url: '/service/contactroles',
  },
  SPECIFIC_TERMS: {
    namespace: 'SpecificTerms',
    url: '/instrument/specificTerms',
  },
  FEE_SEARCH_OPTIONS: {
    namespace: 'FeeSearchOptions',
    url: '/service/feesearchoptions',
  },
  PARTNERSHIP_GRANT_SEARCH_OPTIONS: {
    namespace: 'PartnershipGrantSearchOptions',
    url: '/project/partnershipgrantsearchoptions',
  },
  REVIEW_SEARCH_OPTIONS: {
    namespace: 'ReviewSearchOptions',
    url: '/service/reviewsearchoptions',
  },
});
